import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "9",
      fill: "#F8C52C"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M16.473 10.904h-2.256V7.458q0-.091-.04-.175a.5.5 0 0 0-.115-.149.5.5 0 0 0-.17-.1A.6.6 0 0 0 13.69 7h-3.378a.6.6 0 0 0-.202.035.5.5 0 0 0-.171.1.5.5 0 0 0-.114.148.4.4 0 0 0-.04.175v3.446H7.527a.6.6 0 0 0-.277.069.5.5 0 0 0-.194.185.41.41 0 0 0 .05.48l4.472 5.179q.076.086.186.135a.6.6 0 0 0 .47 0 .5.5 0 0 0 .187-.135l4.473-5.18a.407.407 0 0 0 .05-.48.5.5 0 0 0-.194-.184.6.6 0 0 0-.277-.069"
    }, null, -1)
  ])))
}
export default { render: render }